import React from 'react';
import { IconProps } from '../../../DefaultIcon';

export function EATIcon({ className }: IconProps) {
  return (
    <svg
      width="80"
      height="90"
      viewBox="0 0 80 90"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_4_1845)">
        <path
          d="M70.7879 89.697V13.3333C70.7879 11.3939 69.0909 9.69698 67.1515 9.69698H3.63636C1.69697 9.69698 0 11.1515 0 13.3333V80C0 85.3333 4.36364 89.697 9.69697 89.697H70.7879Z"
          fill="#EAEEF9"
        />
        <path
          d="M52.8484 82.9091H31.2727C30.7878 82.9091 30.0605 82.4242 30.0605 81.697C30.0605 80.9697 30.5454 80.7273 31.2727 80.7273H52.8484C53.3333 80.7273 53.8181 81.2121 53.8181 81.697C53.8181 82.1818 53.3333 82.9091 52.8484 82.9091Z"
          fill="#B0B9CF"
        />
        <path
          d="M25.6969 82.9091H23.2727C22.7878 82.9091 22.0605 82.4242 22.0605 81.697C22.0605 80.9697 22.5454 80.7273 23.2727 80.7273H25.6969C26.1818 80.7273 26.909 81.2121 26.909 81.697C26.909 82.1818 26.4242 82.9091 25.6969 82.9091Z"
          fill="#B0B9CF"
        />
        <path
          d="M9.93945 89.697C14.5455 89.697 18.4243 86.303 19.1516 81.697C19.1516 80.9697 19.8788 80.4848 20.6061 80.4848H78.5455C79.5152 80.4848 80.2425 81.2121 80.0001 82.1818C79.2728 86.5455 75.394 89.697 70.7879 89.697H9.93945Z"
          fill="#00C4B3"
        />
        <path
          d="M38.0607 52.1212C30.3031 52.1212 24 57.9394 23.0304 65.2121C22.7879 66.1818 23.7576 67.1515 24.7273 67.1515H51.394C52.3637 67.1515 53.3334 66.1818 53.091 65.2121C52.1213 57.9394 45.8182 52.1212 38.0607 52.1212Z"
          fill="#00416B"
        />
        <path
          d="M49.697 44.1212C49.697 50.6667 44.3637 55.7576 38.0607 55.7576C31.5152 55.7576 26.4243 50.4242 26.4243 44.1212C26.4243 37.5758 31.7577 32.4848 38.0607 32.4848C44.6061 32.4848 49.697 37.5758 49.697 44.1212Z"
          fill="#EAEEF9"
        />
        <path
          d="M46.3032 44.1212C46.3032 48.7273 42.6668 52.3636 38.0608 52.3636C33.4547 52.3636 29.8184 48.7273 29.8184 44.1212C29.8184 39.5151 33.4547 35.8788 38.0608 35.8788C42.6668 35.8788 46.3032 39.5151 46.3032 44.1212Z"
          fill="#00416B"
        />
        <path
          d="M68.8485 0L56 3.39394C55.5151 3.39394 55.5151 4.12121 55.7576 4.36364L57.9394 6.54545C58.1818 6.78788 58.1818 7.0303 57.9394 7.27273L45.8182 19.3939C45.5758 19.6364 45.3333 19.6364 45.0909 19.3939L39.7576 14.0606C39.5151 13.8182 39.2727 13.8182 39.0303 14.0606L27.6364 25.4545C27.3939 25.697 27.1515 25.697 26.9091 25.4545L21.3333 20.3636C21.0909 20.1212 20.8485 20.1212 20.6061 20.3636L0 40.7273V49.2121L20.6061 28.8485C20.8485 28.6061 21.0909 28.6061 21.3333 28.8485L26.6667 34.1818C26.9091 34.4242 27.1515 34.4242 27.3939 34.1818L38.7879 22.7879C39.0303 22.5455 39.2727 22.5455 39.5151 22.7879L44.8485 28.1212C45.0909 28.3636 45.3333 28.3636 45.5758 28.1212L62.0606 11.8788C62.303 11.6364 62.5454 11.6364 62.7879 11.8788L64.9697 14.0606C65.2121 14.303 65.697 14.303 65.9394 13.8182L69.3333 1.21212C69.5758 0.242424 69.3333 0 68.8485 0Z"
          fill="#00C4B3"
        />
      </g>
      <defs>
        <clipPath id="clip0_4_1845">
          <rect width="80" height="89.697" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
